import * as React from 'react';
import clsx from 'clsx';
import { Base, Text } from '../../Base';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Label-root_3A7JB",
  "addon": "Label-addon_X3KSX",
  "popoverIcon": "Label-popoverIcon_eHEaM",
  "hasTarget": "Label-hasTarget_3hgAQ",
  "hasPopoverIcon": "Label-hasPopoverIcon_IsvXq",
  "required": "Label-required_2YMgy",
  "disabled": "Label-disabled_QMpUF"
};
function Label({
  target,
  required,
  disabled,
  children,
  popoverIcon,
  addon,
  className,
  ...extraProps
}) {
  const hasPopoverIcon = /*#__PURE__*/React.isValidElement(popoverIcon);
  const rootClasses = clsx(styles.root, {
    [styles.required]: required,
    [styles.disabled]: disabled,
    [styles.hasTarget]: target,
    [styles.hasPopoverIcon]: hasPopoverIcon
  }, className);
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    flexAlignItemsCenter: true,
    marginBottom: hasPopoverIcon ? null : 'xsmall',
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsxs(Base, {
      tagName: "label",
      htmlFor: target,
      weight: "regular",
      children: [/*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        children: children
      }), addon && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(Text, {
          color: "light",
          weight: "regular",
          className: styles.addon,
          children: addon
        })]
      })]
    }), popoverIcon && /*#__PURE__*/React.cloneElement(popoverIcon, {
      className: styles.popoverIcon
    })]
  });
}
export default Label;